export const iconFontAwesomeDisasterCrisisHouseFloodWaterCircleArrowRight = (
	<i className="fa-solid fa-house-flood-water-circle-arrow-right"></i>
);
